
import { defineComponent, ref, watch, onMounted, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'


import MusicComponent from '@/components/Music.vue'
import DialogComponent from '@/components/Dialog.vue'

import Moment from 'moment'
import COVERAPP from '@/utils/COVERAPP'

export default defineComponent({
    name: 'App',
    components: {
        MusicComponent,
        DialogComponent,
    },
    computed: {
        ...mapState(['activityData', 'dialogData', 'popData', 'picViewerData'])
    },
    setup (props, context) {
        const $store = useStore()
        const router = useRouter()
        const _this = getCurrentInstance() as any
        const isApp = ref<boolean>(false)
        const musicUrl = ref<string>('')

        const getActDetail = () => {
            _this.proxy.$request('/activity/config', {
                aid: $store.state.aid
            }).then((data: any) => {
                // 设置分享信息
                document.title = data.title
                data.share && setShareData(data) 
                if (data && data.music && data.music.musicUrl) {
                    musicUrl.value = data.music.musicUrl
                } 
                $store.commit('SET_ACTIVITYDATA', data)
                $store.commit('SET_TOPICDATA', {
                    id: data.templateConfig.topicId,
                    title: data.templateConfig.topicTitle,
                })
                // 判断活动状态
                activityStatus(data)
            })
        }

        const activityStatus = (data: any) => {
            if (new Date(data.serverTime).getTime() < new Date(data.startTime).getTime()) {
                $store.commit('SET_DIALOGDATA', {
                    text: `亲，活动于${Moment(data.startTime).format('YYYY年MM月DD日')}-${Moment(data.endTime).format('YYYY年MM月DD日')}正式启动哦！`
                })
            } else if (new Date(data.serverTime).getTime() > new Date(data.endTime).getTime()) {
                $store.commit('SET_DIALOGDATA', {
                    text: '该活动已经结束'
                })
            } else if (!isApp.value && data.isAppShow) {
                $store.commit('SET_DIALOGDATA', {
                    text: '参加该活动需在封面新闻APP中进行',
                    btns: [
                        {
                            text: '确定',
                            className : 'download-btn'
                        }
                    ]
                })
            }
        }

        const setShareData = (data: any) => {
            $store.commit('SET_SHAREDATA', {
                title: data.share.title,
                desc: data.share.desc,
                imgUrl: data.share.imgUrl || 'https://wapcdn.thecover.cn/cdn/wap/img/fengmian_logo.png',
                link: window.location.href
            })
        }

        watch(() => router.currentRoute.value, (to, from) => {
            if (to.fullPath != from.fullPath) {
                $store.commit('SET_DIALOGDATA', null)
                _this.proxy.$common.pageLoading()
                document.documentElement.scrollTop = 0
            }
        })

        getActDetail()

        onMounted(() => {
            isApp.value = COVERAPP.Attribute.isApp()
        })

        return {
            musicUrl
        }
    }
})

